import { gql } from '@apollo/client';

export const QUERY_SCHOOL_CHILDREN = gql`
  query schoolChidren($asRegularUser: Boolean) {
    fetchMySchools(asRegularUser: $asRegularUser) {
      id
      attributes {
        name
        schools {
          data {
            id
            attributes {
              name
            }
          }
        }
      }
    }
  }
`;
